import { API, graphqlOperation } from 'aws-amplify'

const DeleteFloorWarden = `mutation DeleteFloorWarden($email: AWSEmail!, $group: String) {
    deleteFloorWarden(email: $email, group: $group) {
        email
        tenantId
        buildingId
        propertyId
    }
}`

const deleteFloorWarden = async (email, group) => {
    let deleteDetails = {
        email: email,
        group: group,
    }

    let response = ''
    try {
        response = await API.graphql(graphqlOperation(DeleteFloorWarden, deleteDetails))
    } catch (e) {
        response = e
    }
    return response
}

export default deleteFloorWarden
